// extracted by mini-css-extract-plugin
export default {"activationRange":"ActivationRange_activationRange__cNQ3q","minRange":"ActivationRange_minRange__RM7sd"};